// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__22D2P","text":"styles_text__1p1C0","number":"styles_number__1-Rwj"};